<template>

  <section class="panel-facts">
    <div class="section" id="HomeFacts">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-4" v-for="(f, index) in facts" v-bind:key="index">
                        <panel-fact
                          v-bind:titre-fact="f.titre"
                          v-bind:message-fact="f.message"
                          v-bind:icone-fact="f.icone"/>
                    </div>
                </div>
            </div>
        </div>
  </section>

</template>

<script lang="js">
  import PanelFact from '@/components/PanelFact.vue'

  export default  {
    name: 'panel-facts',
    props: [],
    mounted() {

    },
    data() {
      return {
        facts : [
          {titre : 'Billetterie sur mesure', icone : 'fa fa-5x fa-ticket', message : 'Voyez avec quelle facilité vous pouvez créer, promouvoir et gérer votre billeterie'},
          {titre : 'Paiement par USSD', icone : 'fa fa-5x fa-mobile-phone', message : 'Composez via MTN CI le <b>*133*135#</b><br/>Composez via Orange CI le <b>#144*4821#</b>'},
          {titre : 'Paiement securisé', icone : 'fa fa-5x fa-usd', message : 'Vendez des billets en ligne et Acceptez des paiements en ligne 24H/24 7j/7'}
        ]
      }
    },
    methods: {

    },
    computed: {

    },
    components: {
      PanelFact
    }
}
</script>
